import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { OperationKey } from '../models/valueObjects/OperationKey';

export class OperationKeyMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(edge: any): OperationKey {
    const {
      node: { id, shortDescription },
      role,
      cipherData,
      wrappedByKeyId,
      wrappedKeyId,
    } = edge;

    return new OperationKey(
      this.gqlIdEncoder.decode(id),
      shortDescription,
      role,
      cipherData,
      wrappedKeyId ? this.gqlIdEncoder.decode(wrappedKeyId) : null,
      wrappedByKeyId ? this.gqlIdEncoder.decode(wrappedByKeyId) : null
    );
  }
}
